import React from 'react';
import { faFileCircleExclamation } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const FileExclamationIcon = ({ toolTipText = 'Course Expired' }) => (
  <Icon tooltip={toolTipText} iconObj={faFileCircleExclamation} />
);

export default FileExclamationIcon;